import React from 'react';
import PropTypes from 'prop-types';

import './style';

const Footer = (props, context) => {
  const { theme: { colorPrimary, textPrimary } } = context;
  return (
    <footer>
      <div className="content-grid">
        <div style={{ color: textPrimary }}><a href="https://github.com/flexdinesh/flexdinesh.github.io" target="_blank" rel="noopener noreferrer" style={{ color: colorPrimary }}>Original Theme</a> by <a href="https://github.com/flexdinesh" target="_blank" rel="noopener noreferrer" style={{ color: colorPrimary }}>Dinesh</a> </div>
      </div>
    </footer>
  );
};

Footer.contextTypes = {
  theme: PropTypes.any,
  switchTheme: PropTypes.func
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js